import React from 'react';
import { Bell, Settings, User, HelpCircle, Plus } from 'lucide-react';
export function Header() {
  return <header className="bg-white border-b border-gray-200" data-id="element-236">
      <div className="max-w-7xl mx-auto px-6" data-id="element-237">
        <div className="flex items-center justify-between h-16" data-id="element-238">
          {/* Logo and Navigation */}
          <div className="flex items-center space-x-8" data-id="element-239">
            <div className="flex items-center space-x-3" data-id="element-240">
              <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center" data-id="element-241">
                <span className="text-white font-bold text-sm" data-id="element-242">TS</span>
              </div>
              <span className="text-xl font-semibold text-gray-900" data-id="element-243">
                TypeShift
              </span>
            </div>
            <nav className="hidden md:flex items-center space-x-6" data-id="element-244">
              <a href="#" className="text-purple-600 hover:text-gray-900" data-id="element-245">
                Products
              </a>
              <a href="#" className="text-gray-600 font-medium" data-id="element-246">
                Claims Validation
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-247">
                Reports
              </a>
            </nav>
          </div>
          {/* Actions */}
          <div className="flex items-center space-x-4" data-id="element-248">
            <button className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center space-x-2" data-id="element-249">
              <Plus className="w-4 h-4" data-id="element-250" />
              <span data-id="element-251">Create New</span>
            </button>
            <div className="flex items-center space-x-2" data-id="element-252">
              <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-253">
                <HelpCircle className="w-5 h-5" data-id="element-254" />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-255">
                <Bell className="w-5 h-5" data-id="element-256" />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-257">
                <Settings className="w-5 h-5" data-id="element-258" />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-259">
                <User className="w-5 h-5" data-id="element-260" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>;
}